module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-autocomplete', {
    attrs: {
      "icon": "",
      "select-when-unmatched": _vm.cChange,
      "oon-icon-click": "cChange",
      "fetch-suggestions": _vm.querySearchAsync,
      "props": {
        label: 'mechanismname',
        value: 'mechanismname'
      },
      "placeholder": _vm.$t('app_srcmechan')
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.acVal),
      callback: function($$v) {
        _vm.acVal = $$v
      },
      expression: "acVal"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19e4fb42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/mechanism_selector.vue
// module id = 979
// module chunks = 0